<!-- Header Section -->
<section class="banner-carousel">
  <div id="bannerCarousel" class="bannerCarousel" [ngClass]="{'dealer-margin-mobile': hasDealerCode}">
    <ng-container *ngIf="processedBannerList?.length === 0; else loadingContent">
      <div *ngFor="let item of skeletonService.generateFake(1);let i = index;">
        <ngx-skeleton height="570px"></ngx-skeleton>
      </div>
    </ng-container>
    
    <img [attr.fetchpriority]="'high'" [src]="environment1 + 'Square-T-skyblue.png'" class="t-image" alt="T">
    <div class="horizontal-line"></div>
    <div class="vertical-line"></div>
    <div class="bottom-horizontal-line"></div>
    <div class="bottom-vertical-line"></div>

    <ng-template #loadingContent>
      <owl-carousel-o [options]="customOptionsForBanner">
        <ng-container *ngFor="let banner of processedBannerList">
          <ng-template carouselSlide [id]="banner?.id">
            <a [routerLink]="banner?.banner_link" [ngStyle]="{'cursor': banner?.banner_link ? 'pointer' : 'not-allowed'}">
              <picture class="top-banner-wrapper">
                <source [srcset]="environment1 + banner.path" media="(max-width: 768px)">
                <source [srcset]="environment1 + banner.path" media="(min-width: 769px)">
                <img 
                  [src]="updateImageSize(environment1 + banner.path)"
                  width="100%" 
                  height="362px" 
                  role="button" 
                  loading="eager"
                  [alt]="banner.title"
                  fetchpriority="high"
                  [ngStyle]="{ 'margin-top': isBannerMobile ? '0px' : '102px' }"
                />
              </picture>
            </a>
          </ng-template>
        </ng-container>
      </owl-carousel-o>
    </ng-template>
  </div>
  <section class="ai_assistance_main_section">
            <div class="ai_assistance_sub_section">
                <h3>Click here to use Our Fleetverse.ai Assistant</h3>
                <div class="down_arrow_collection d-flex justify-content-between gap-3">
                  <div class="down_arrow_icon_container me-3" style="width: 0px;">
                    <img [src]="environment1 + 'down_arrow.png'" class="down_arrow_icon" alt="down_arrow">
                    <img [src]="environment1 + 'down_arrow.png'" class="down_arrow_icon" alt="down_arrow">
                  </div>
                  <div class="down_arrow_icon_container me-3" style="width: 0px;">
                    <img [src]="environment1 + 'down_arrow.png'" class="down_arrow_icon" alt="down_arrow">
                    <img [src]="environment1 + 'down_arrow.png'" class="down_arrow_icon" alt="down_arrow">
                  </div>
                  <div class="down_arrow_icon_container me-3" style="width: 0px;">
                    <img [src]="environment1 + 'down_arrow.png'" class="down_arrow_icon" alt="down_arrow">
                    <img [src]="environment1 + 'down_arrow.png'" class="down_arrow_icon" alt="down_arrow">
                  </div>
                </div>
                <button class="ai_background_button"><img [src]="environment1 + 'button_gif.gif'" class="button_icon" alt="">Try Fleetverse.ai now</button>
            </div>
            <img [src]="environment1 + 'AI.png'" class="ai_assistance" alt="">

  </section>
</section>
<!-- Features Section -->
 <section>
<section class="frames_main_section">
      <div class="container">
          <h3>Make Smarter Decisions Using Fleetverse.ai</h3>
          <div class="carousile_container_section">
              <owl-carousel-o [options]="customOptions">
                <ng-template carouselSlide>
                    <div class="carousile_container">
                    <img [src]="environment1 + 'carousile_01.gif'" alt="Carousel Image 1" class="carousel-img">
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="carousile_container">
                    <img [src]="environment1 + 'carousile_02.gif'" alt="Carousel Image 2" class="carousel-img">
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="carousile_container">
                    <img [src]="environment1 + 'carousile_03.gif'" alt="Carousel Image 3" class="carousel-img">
                    </div>
                </ng-template>
                </owl-carousel-o>

          </div>
      </div>
</section>

<!-- Guide Section -->
<section class="user_guidance_main_section">
            <div class="container">
                <div class="text_container_section">
                    <h3>Your Guide to Using Fleetverse.ai</h3>
                    <button *ngIf="!isMobile">Watch how it works</button>
                </div>
                <div class="user_guidance_sub_sections">
                    <div class="user_guidance_block">
                        <div class="number_container">
                            <h4>01</h4>
                            <img [src]="environment1 + 'Arrow.svg'" alt="">
                        </div>
                        <img [src]="environment1 + 'Container_01.png'" class="user_guidances_img" alt="">
                    </div>
                    <div class="user_guidance_block">
                        <div class="number_container">
                            <h4>02</h4>
                            <img [src]="environment1 + 'copy.svg'" alt="">
                        </div>
                        <img [src]="environment1 + 'Container_02.png'" class="user_guidances_img" alt="">
                    </div>
                    <div class="user_guidance_block">
                        <div class="number_container">
                            <h4>03</h4>
                            <img [src]="environment1 + 'Document.svg'" alt="">
                        </div>
                        <img [src]="environment1 + 'Container_03.png'" class="user_guidances_img" alt="">
                    </div>
                    <div class="user_guidance_block">
                        <div class="number_container">
                            <h4>04</h4>
                            <img [src]="environment1 + 'Frame.svg'" alt="">
                        </div>
                        <img [src]="environment1 + 'Container_04.png'" class="user_guidances_img" alt="">
                    </div>
                </div>
                <button  class="guide-mobile-btn" *ngIf="isMobile">Watch how it works</button>
            </div>
</section>

<!-- Video Section -->
<section class="video_placeholder_main_section">
    <div class="container">
        <div class="text_container_section">
            <h4>Watch how it works</h4>
            <button *ngIf="!isMobile">Watch how it works</button>
        </div>
        <div class="video_placeholder_container">
            <p>Video placeholder</p>
        </div>
        <button class="vedio-mobile-btn" *ngIf="isMobile">Watch how it works</button>
    </div>
</section>

<!-- FAQ Section -->
<section class="faqs_main_section">
            <div class="container">
                <div class="custom_qna_section">
                    <h5>Customer Q&A</h5>
                    <p>Can't find what you are looking for?</p>
                    <input type="text" placeholder="Write your question here" name="" id="">
                    <button>Post your question</button>
                </div>
                <div class="others_qna_section">
                    <div class="qna_question_and_answers_containers">
                        <p class="question"><strong>Q.</strong> Where can I take a test drive of the vehicle?</p>
                        <p class="answers"><strong>A.</strong> Lorem ipsum dolor sit amet consectetur. Eget nibh at morbi proin aliquet. Eu nisl adipiscing consequat pulvinar nullam urna eu etiam erat pellentesque.</p>
                        <div class="by_and_liks">
                            <p class="by">By Vipin on 31 July, 2021</p>
                            <!-- <div class="likes_and_dislikes">
                                <button class="likes"><i class="fa-regular fa-thumbs-up"></i> 43</button>
                                <button class="dislikes"><i class="fa-regular fa-thumbs-down"></i> 43</button>
                            </div> -->
                        </div>
                    </div>
                    <div class="qna_question_and_answers_containers">
                        <p class="question"><strong>Q.</strong> Where can I take a test drive of the vehicle?</p>
                        <p class="answers"><strong>A.</strong> Lorem ipsum dolor sit amet consectetur. Eget nibh at morbi proin aliquet. Eu nisl adipiscing consequat pulvinar nullam urna eu etiam erat pellentesque.</p>
                        <div class="by_and_liks">
                            <p class="by">By Vipin on 31 July, 2021</p>
                            <!-- <div class="likes_and_dislikes">
                                <button class="likes"><i class="fa-regular fa-thumbs-up"></i> 43</button>
                                <button class="dislikes"><i class="fa-regular fa-thumbs-down"></i> 43</button>
                            </div> -->
                        </div>
                    </div>
                    <div class="qna_question_and_answers_containers">
                        <p class="question"><strong>Q.</strong> Where can I take a test drive of the vehicle?</p>
                        <p class="answers"><strong>A.</strong> Lorem ipsum dolor sit amet consectetur. Eget nibh at morbi proin aliquet. Eu nisl adipiscing consequat pulvinar nullam urna eu etiam erat pellentesque.</p>
                        <div class="by_and_liks">
                            <p class="by">By Vipin on 31 July, 2021</p>
                            <!-- <div class="likes_and_dislikes">
                                <button class="likes"><i class="fa-regular fa-thumbs-up"></i> 43</button>
                                <button class="dislikes"><i class="fa-regular fa-thumbs-down"></i> 43</button>
                            </div> -->
                        </div>
                    </div>
                    <button *ngIf="!isDownArrow"   class="qna_view_all_btn">View all answers 
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <g clip-path="url(#clip0_2829_1812)">
                                <path d="M10.9766 9.99999L6.85156 5.87499L8.0299 4.69666L13.3332 9.99999L8.0299 15.3033L6.85156 14.125L10.9766 9.99999Z" fill="url(#paint0_linear_2829_1812)"/>
                            </g>
                            <defs>
                                <linearGradient id="paint0_linear_2829_1812" x1="6.92101" y1="5.09441" x2="14.4128" y2="5.86931" gradientUnits="userSpaceOnUse">
                                <stop stop-color="#1C429E"/>
                                <stop offset="0.99707" stop-color="#0A0A5F"/>
                                </linearGradient>
                                <clipPath id="clip0_2829_1812">
                                <rect width="20" height="20" fill="white"/>
                                </clipPath>
                            </defs>
                            </svg>
                    </button>
                    <button *ngIf="isDownArrow"   class="qna_view_all_btn">View all answers 
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <g clip-path="url(#clip0_2829_5756)">
                            <path d="M10.0001 10.9767L14.1251 6.85168L15.3034 8.03002L10.0001 13.3334L4.69678 8.03002L5.87511 6.85168L10.0001 10.9767Z" fill="url(#paint0_linear_2829_5756)"/>
                        </g>
                        <defs>
                            <linearGradient id="paint0_linear_2829_5756" x1="4.81042" y1="7.09475" x2="16.3183" y2="10.2822" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#1C429E"/>
                            <stop offset="0.99707" stop-color="#0A0A5F"/>
                            </linearGradient>
                            <clipPath id="clip0_2829_5756">
                            <rect width="20" height="20" fill="white"/>
                            </clipPath>
                        </defs>
                        </svg>
                    </button>
                </div>
            </div>
        </section>

</section>
